/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*********************************!*\
  !*** ./src/assets/js/header.js ***!
  \*********************************/
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var HeaderSection = /*#__PURE__*/function () {
  function HeaderSection() {
    _classCallCheck(this, HeaderSection);

    this.selectors = {
      headerId: "header"
    };
  }

  _createClass(HeaderSection, [{
    key: "initHeaderObserver",
    value: function initHeaderObserver() {
      var prevScrollPos = window.pageYOffset;
      var customHeaderShow = new CustomEvent('showHeader');
      var customHeaderHide = new CustomEvent('hideHeader');
      var header = document.getElementById(this.selectors.headerId);

      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset; //console.log(document.querySelector('[aria-labelledby="mobile-menu"]').style.display, 'header display');

        if (currentScrollPos > 130) {
          if (prevScrollPos > currentScrollPos) {
            header.style.top = "0";
            document.dispatchEvent(customHeaderShow);
          } else if (prevScrollPos < currentScrollPos && document.querySelector('[aria-labelledby="mobile-menu"]').style.display == 'none') {
            document.dispatchEvent(customHeaderHide);
            header.style.top = "-100px";
          }
        }

        prevScrollPos = currentScrollPos;
      };
    }
  }, {
    key: "initLogoListener",
    value: function initLogoListener() {
      if (document.querySelector('.site-logo a') != null) {
        var logo = document.querySelector('.site-logo a');
        var template = logo.getAttribute('data-template');

        if (template === 'index') {
          logo.addEventListener('click', function (event) {
            event.preventDefault();
            var Ycoords = 0;
            window.scrollTo({
              top: Ycoords,
              behavior: "smooth"
            });
          });
        }
      }
    }
  }, {
    key: "initListeners",
    value: function initListeners() {
      this.initHeaderObserver();
    }
  }]);

  return HeaderSection;
}();

document.addEventListener("DOMContentLoaded", function () {
  var headerEvent = new HeaderSection();
  headerEvent.initListeners();
});
/******/ })()
;